import {
    GET_STATE_ERROR,
    GET_STATE_REQUEST,
    GET_STATE_SUCCESS,
    ADD_STATE_ERROR,
    ADD_STATE_REQUEST,ADD_STATE_SUCCESS,
    UPDATE_STATE_ERROR,
    UPDATE_STATE_REQUEST,UPDATE_STATE_SUCCESS,
    DELETE_STATE_ERROR,
    DELETE_STATE_REQUEST,
    DELETE_STATE_SUCCESS

  } from "../actions/types";
  
  export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
      case GET_STATE_REQUEST:
        return {
          loading: true,
        };
      case GET_STATE_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case GET_STATE_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
        case ADD_STATE_REQUEST:
          return {
              loading: true,
          };
      case ADD_STATE_SUCCESS:
          return {
              ...state,
              loading: false,
              payload: [payload],
          };
      case ADD_STATE_ERROR:
          return {
              ...state,
              loading: false
          };
          case UPDATE_STATE_REQUEST:
            return {
                loading: true,
            };
        case UPDATE_STATE_SUCCESS:
            return {
                ...state,
                loading: false,
                payload: [payload],
            };
        case UPDATE_STATE_ERROR:
            return {
                ...state,
                loading: false
            };
            case DELETE_STATE_REQUEST:
              return {
                  loading: true,
              };
          case DELETE_STATE_SUCCESS:
              return {
                  ...state,
                  loading: false,
                  payload: [payload],
              };
          case DELETE_STATE_ERROR:
              return {
                  ...state,
                  loading: false
              };


      default:
        return state;
    }
  }
  